document.addEventListener("DOMContentLoaded", () => {
    const openModalButton = document.querySelectorAll('.open-modal');
    if (openModalButton.length > 0) {
        openModalButton.forEach((button) => {
            button.addEventListener('click', () => {
                const dataTarget = button.getAttribute('data-target');
                const modal = document.querySelector(dataTarget);
                modal.classList.remove('hidden');

                document.querySelector('body').classList.add('overflow-hidden');
                document.querySelector('html').classList.add('overflow-hidden');
            });
        })

        const modals = document.querySelectorAll('.modal');
        if (modals.length > 0) {
            modals.forEach((modal) => {
                const closeModalButton = modal.querySelector('.close-modal');
                closeModalButton.addEventListener('click', () => {
                    modal.classList.add('hidden');

                    document.querySelector('body').classList.remove('overflow-hidden');
                    document.querySelector('html').classList.remove('overflow-hidden');
                });
            })
        }
    }

});
